import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './Provider';
import Spinner from './common/Spinner';

/**
 * GuestRoute component - Only allows access to unauthenticated users
 * Redirects authenticated users away from guest-only pages (like login)
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render for guests
 * @param {string} props.redirectTo - Where to redirect authenticated users (default: '/')
 */
function GuestRoute({ children, redirectTo = '/' }) {
  const { user, loading } = useContext(AuthContext);

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="guest-route-loading">
        <Spinner 
          size="medium" 
          customText="Checking authentication..."
          showText={false}
        />
      </div>
    );
  }

  // If user is authenticated, redirect them away from guest-only page
  if (user) {
    console.log('User is authenticated, redirecting from guest-only page to:', redirectTo);
    return <Navigate to={redirectTo} replace />;
  }

  // User is not authenticated, allow access to guest-only page
  return children;
}

export default GuestRoute;